var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileGqlSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "68px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 16H16V9H1V16Z",
    fill: "#F98B9E",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1L3 5H7V1Z",
    fill: "#9AA7B0",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1V6H3V8H13V1H8Z",
    fill: "#9AA7B0",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01991 15.016C2.50748 15.016 1.513 13.9386 1.513 12.5298V12.516C1.513 11.1624 2.54891 10.016 4.00609 10.016C4.84864 10.016 5.36659 10.2508 5.86383 10.6721L5.32516 11.3143C4.95223 11.0036 4.5862 10.8033 3.97156 10.8033C3.08068 10.8033 2.40388 11.5768 2.40388 12.5022V12.516C2.40388 13.5105 3.05996 14.2425 4.04753 14.2425C4.50333 14.2425 4.9177 14.0975 5.21466 13.8765V12.9787H3.97847V12.2328H6.03648V14.2632C5.55996 14.6707 4.87626 15.016 4.01991 15.016Z",
    fill: "#231F20",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5129 14.4577L10.9678 15.0649L10.3882 14.5474C9.98109 14.8372 9.47739 15.0028 8.91849 15.0028C7.43499 15.0028 6.39999 13.8781 6.39999 12.5188C6.39999 11.1457 7.44879 10.0072 8.93229 10.0072C10.4158 10.0072 11.4508 11.1319 11.4508 12.4912C11.4508 13.057 11.2714 13.5676 10.9609 13.9885L11.5129 14.4577ZM8.93187 14.1162C9.22986 14.1162 9.48899 14.0447 9.71572 13.9148L8.93187 13.2391L9.49364 12.6044L10.2904 13.3321C10.433 13.0852 10.4607 12.8428 10.4607 12.518V12.505C10.4607 11.6214 9.81937 10.8938 8.91892 10.8938C8.01847 10.8938 7.39999 11.6084 7.39999 12.492V12.505C7.39999 13.3886 8.03142 14.1162 8.93187 14.1162Z",
    fill: "#231F20",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10H13V14H15.5V15H12V10Z",
    fill: "#231F20",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileGqlSvgrepoCom);
export default __webpack_public_path__ + "static/media/file-gql-svgrepo-com.82af84d3095a171805e202a07635d81e.svg";
export { ForwardRef as ReactComponent };